import React, { useState } from "react";
import PublishedListing from "@/pageTpls/PublishedListing";
import { useGetOnePublishedOrUnpublishedTpl } from "@/utils/react-query-hooks/tci";
import { Breadcrumbs, ButtonTertiaryCompact, colors2, OKELink, UI_CAPTION } from "oolib";
import { useParams } from "react-router-dom";
import { BREADCRUMB_WRAPPER_STYLE } from "../LAYOUT_CONSTANTS";
import PublishedPageV2 from "@/pageTpls/PublishedPage";
import PublishedPageV3 from "@/pageTpls/PublishedPageV3";
import { SM_UIContent } from "../SM_UIContent";
import SM_ContentLanding from "../SM_ContentLanding";
import { useGetQueryData } from "@/utils/react-query-hooks/general";
import { useLocalStorage } from "@/utils/customHooks/useLocalStorage";
import { ArrowArcLeft, ArrowArcRight } from "@phosphor-icons/react";


export default ({ contentType: contentTypeProp, contentId, disableBreadcrumbsOnV2, selfServeActions, onBack } = {}) => {
  const params = useParams();

  // self-serve renders this inline (no contentType route param) and passes
  // the content's type + id directly instead.
  const contentType = contentTypeProp || params.contentType;

  const {data: tpl, status: fetchTplStatus} = useGetOnePublishedOrUnpublishedTpl({
    contentType
  })

  const [contentTitle, setContentTitle] = useState('...')
  const [publishedPageVersion, setPublishedPageVersion] = useLocalStorage("dev_published_page_version", "v3");

  const platformConfigs = useGetQueryData("platformConfigs");
  const isProd = import.meta.env.VITE_ENV === "prod";
  const disabledFeatures = platformConfigs?.FEATURES_DISABLED_ON_PROD || [];
  const publishedPageV3Disabled = isProd && disabledFeatures.includes("publishedPageV3");
  const isGroupsStyle1 = tpl?.category === "groupsStyle1";
  const showV2 = publishedPageV3Disabled || isGroupsStyle1 || publishedPageVersion === "v2";
  const canToggle = !publishedPageV3Disabled && !isGroupsStyle1;

  return <div>
      {/* On V3 the toggle lives in the floating View-settings modal, so this
          banner only shows on V2 (to switch back to the new UI). */}
      {canToggle && showV2 && (
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "3px 14px",
          backgroundColor: colors2.grey5,
          borderBottom: `1px solid ${colors2.grey10}`,
          gap: 12,
        }}>
          <UI_CAPTION>
            {showV2
              ? "You're now viewing the old UI."
              : "You're now viewing the new UI."}
          </UI_CAPTION>
          <ButtonTertiaryCompact
            onClick={() => setPublishedPageVersion(showV2 ? "v3" : "v2")}
          >
            <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
              {showV2
                ? <ArrowArcRight size={14} weight="bold" />
                : <ArrowArcLeft size={14} weight="bold" />}
              {showV2 ? "Switch to new UI" : "Switch to old UI"}
            </span>
          </ButtonTertiaryCompact>
        </div>
      )}
      {showV2
        ? <>
            {/* self-serve back bar — only on V2 (V3 has its own back nav) */}
            {onBack && (
              <div
                style={{
                  borderBottom: `1px solid ${colors2.grey10}`,
                  padding: "0.8rem 2rem",
                }}
              >
                <OKELink onClick={onBack}>
                  <UI_CAPTION>Go Back</UI_CAPTION>
                </OKELink>
              </div>
            )}
            {!disableBreadcrumbsOnV2 && (
              <div style={BREADCRUMB_WRAPPER_STYLE}>
                <Breadcrumbs
                  links={[
                    {
                      display: SM_UIContent.SM_TCI.display.datasets,
                      to: "/datasets",
                    },
                    {
                      display: tpl?.general?.content?.title,
                      to: `/datasets/${tpl?.kp_content_type}`
                    },
                    {
                      display: contentTitle
                    }
                  ]}
                />
              </div>
            )}
            <PublishedPageV2
              onboardingProps={
                contentId ? { contentType, contributionId: contentId } : undefined
              }
              selfServeActions={selfServeActions}
              getContentTitle={(title) => {
                setContentTitle(title)
              }}
            />
          </>
        : <PublishedPageV3 contentType={contentType} contentId={contentId} selfServeActions={selfServeActions} />
      }

    </div>

};
